import EmailReport from './EmailReport';

export default EmailReport;
